import { GiViolin } from "react-icons/gi";
import { TbMathIntegrals, TbBinaryTree, TbBrandNextjs } from "react-icons/tb";
import { FaReact, FaNodeJs, FaJava } from "react-icons/fa";
import { SiMongodb, SiPython, SiFirebase } from "react-icons/si";
import { AiFillHtml5, AiFillGithub } from "react-icons/ai";
import { DiCss3 } from "react-icons/di";
import { FaLinux } from "react-icons/fa";
import { MdHttp, MdOutlineNetworkWifi3Bar  } from "react-icons/md";
import { randArray, randRange } from "./helpers";
import React from "react";
import { fragments_config } from "../config/settings";
import { letters_matrices } from "./letters";
import { color } from "framer-motion";


const elements = [
   <GiViolin />,
   <TbMathIntegrals />,
   <FaReact />,
   <FaNodeJs />,
   <SiMongodb />,
   <TbBinaryTree />,
   <TbBrandNextjs />,
   <SiPython />,
   <FaJava />,
   <AiFillHtml5 />,
   <DiCss3 />,
   <SiFirebase />,
   <AiFillGithub />,
   <FaLinux />,
   <MdHttp />,
   <MdOutlineNetworkWifi3Bar />,
];

export function getRandomFragment(size, color) {
   const el = randArray(elements);
   return React.createElement(el.type, { size, color });
}

export const patterns = {
   scattered({ fragments, block_width, block_height, ROWS, COLUMNS })  {
      const OPACITY = 0.05
      const COLOR = "#fff"
      for (let i = 0; i < ROWS; i++) {
         for (let j = 0; j < COLUMNS; j++) {
            const noiseX = randRange(0, 30);
            const noiseY = randRange(0, 30);
            const coin = randRange(0, 8);
            const fragment = fragments[COLUMNS * i + j][1].current
            if (coin < 1){
               fragment?.changeFragmentColor(COLOR)
               fragment?.resetFragment(
                  block_width * j + noiseX,
                  block_height * i + noiseY
               );
               fragment?.changeOpacity(OPACITY)
            }
            else
               fragment?.resetFragment(-100, -100);
         }
      }
   },
   triangular({ fragments, block_width, block_height, ROWS, COLUMNS })  {
      const OPACITY = 0.05
      for (let i = 0; i < ROWS; i++) {
         for (let j = 0; j < COLUMNS; j++) {
            const fragment = fragments[COLUMNS * (i) + j][1].current
            if (j <= i * Math.round(COLUMNS / ROWS) && randRange(0, 3) < 1){
               place_fragment_in_cell(fragment, i, (COLUMNS - j), block_width, block_height)
               fragment?.changeOpacity(OPACITY)
            }
            else
               fragment?.resetFragment(-100, -100);
         }
      }
   },
   cubic({ fragments, block_width, block_height, ROWS, COLUMNS })  {},
   text({ fragments, block_width, block_height, ROWS, COLUMNS, text }){
      const OPACITY = 1
      const COLOR = "66bb6a"
      const text_matrix = get_text_matrix(ROWS, COLUMNS, text)
      console.log(text);
      console.log(text_matrix);
      
      for (let i = 0; i < ROWS; i++) {
         for (let j = 0; j < COLUMNS; j++) {
            const fragment = fragments[COLUMNS * i + j][1].current
            if (text_matrix[i][j] === 1){
               fragment?.changeFragmentColor(COLOR)
               fragment?.changeOpacity(OPACITY)
               place_fragment_in_cell(fragment, i, j, block_width, block_height)
               
            }
            else{
               fragment?.resetFragment(-100, -100);
            }
         }
      }
   }
};

function get_text_matrix(rows, cols, text){
   const matrix = Array.from({ length: rows }, () => Array(cols).fill(0));
   const letter_dim = fragments_config.LETTER_DIM + fragments_config.LETTERS_MARGIN;
   const max_letters = Math.floor(cols/letter_dim)
   const baseline = Math.floor(rows/2) + Math.floor(fragments_config.LETTER_DIM)
   const topline = baseline - letter_dim
   console.log(text)
   text = surround_str(text, max_letters, fragments_config.TEXT_FILLER)
   console.log(text);
   
   for (let block_num = 0; block_num < (max_letters); block_num++) {
      const current_char = text[block_num]
      const char_matrix = letters_matrices[fragments_config.LETTER_DIM][current_char]
      if(!char_matrix) return alert("char matrix not found" + current_char)
      const block_i = topline
      const block_j = block_num * letter_dim;
      for(let i = 0; i < letter_dim - fragments_config.LETTERS_MARGIN; i++) {
         for(let j = 0; j < letter_dim - 1; j++){
            matrix[block_i + i][block_j + j] = char_matrix[i][j]
         }
      } 
    }
    return matrix;
}

function surround_str(str, len, filler){
   const free = len - str.length   
   if(free < 0) return console.error("error in surround_str_spaces")
   const spaces_l = filler.repeat(Math.floor(free/2));
   const spaces_r = filler.repeat(Math.ceil(free/2));
   return spaces_l + str + spaces_r
}

// Place the fragment in the cell i,j in the matrix
function place_fragment_in_cell(fragment, i, j,  block_width, block_height){
   fragment?.resetFragment(
      block_width * j,
      block_height * i
   );
}

export const patternsFlow = ["scattered", "scattered","scattered", "scattered",];
